import { GetterTree, Getter } from 'vuex';
import { RootState } from '@/store/types';
import { UserState } from './types';

export const getlistUsers: Getter<UserState, RootState> = state => state.listUsers || [];

export const getAuthStatus: Getter<UserState, RootState> = state => state.authenticated || false;

export const getErrorStatus : Getter <UserState, RootState > = state => state.errorStatus;

export const getSessionStatus: Getter<UserState, RootState> = state => state.sessionLog || false;

export const getCurrentUser: Getter<UserState, RootState> = state => state.currentUser || { login: "", password: "" };

export const isUserLogedIn: Getter<UserState, RootState> = state => state.currentUser && state.currentUser.login;

export const getNomDossier: Getter<UserState, RootState> = state => state.nomDossier;

export const getKeyDossierMobi: Getter<UserState, RootState> = state => state.keyDossier;

export const getEnvDossier: Getter<UserState, RootState> = state => state.envDossier;

export const getAnnonce: Getter<UserState, RootState> = state => state.annonce;

export const getters: GetterTree<UserState, RootState> = {
  getlistUsers,
  getAuthStatus,
  getErrorStatus,
  getSessionStatus,
  getCurrentUser,
  isUserLogedIn,
  getNomDossier,
  getEnvDossier,
  getAnnonce,
  getKeyDossierMobi
}